/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable react/prop-types */
import React from 'react';

import {useDispatch} from 'react-redux';

import * as modalActions from '@/actions/modalActions';
import InputFieldSpinner from '@/components/inputspinner/InputSpinner';
import {ADVANCE_SETUP_RESTRICTION, MANUAL_CONTROL_THRESHOLD_OPTION} from '@/constants/advSetupConstant';
import * as APPDATA from '@/constants/pcConstAppData';

import './GeneralSetup.scss';
import '../reusable/AdvSetup.less';

const MAX_VALUE = 1000;
const MIN_VALUE = -1000;
const MAX_DIGIT_AFTER_DECIMAL = 1;
const INCREMENT_VALUE = 0.1;

const input = 'input';
const toggle = 'toggle';
const select = 'select';
const toggleSwitch = 'switch';

function GeneralSetup({
  manualControlThreshold,
  primingVolume,
  autoMixingEnabled,
  // hideMembraneFillingCycle,
  handleSetSkipPriming,
  handleChangeManualControlThreshold,
  handleChangePrimingVolume,
  mixingInterval,
  handleChangeMixingInterval,
  mixingCycle,
  handleChangeMixingCycle,
  generateSelectField,
  generateToggle,
  handleToggleAutoMixing,
  handleToggleAutoRecovery,
  autoRecoveryEnabled,
  generateSwitchField,
  handleToggleHighVolumeBuffer,
  highVolumeBufferEnabled,
}) {
  const dispatch = useDispatch();

  const onChange2 = (e) => {
    if (e.type) {
      switch (e.type) {
        case APPDATA.FIELD_NAME.PRIMING_VOLUME:
          handleChangePrimingVolume(Number(e.value));
          break;
        case APPDATA.FIELD_NAME.SAFETY_THRESHOLD:
          handleChangeManualControlThreshold(e.value);
          break;
        case APPDATA.FIELD_NAME.AUTO_MIXING_EVERY:
        case APPDATA.FIELD_NAME.AUTO_MIXING_EVERY_TITLE:
          handleChangeMixingInterval(e.value);
          break;
        case APPDATA.FIELD_NAME.MIXING_CYCLE:
          handleChangeMixingCycle(e.value);
          break;
        default:
          break;
      }
    }
  };

  const onClick = (e) => {
    let value;
    const info = undefined;
    let maxValue = MAX_VALUE;
    let minValue = MIN_VALUE;
    let maxDigitAfterDecimal = MAX_DIGIT_AFTER_DECIMAL;
    let incrementValue = INCREMENT_VALUE;

    switch (e.currentTarget.id) {
      case APPDATA.FIELD_NAME.MEMBRANE_FILLING_CYCLE:
        value = Number(primingVolume);
        minValue = ADVANCE_SETUP_RESTRICTION[APPDATA.FIELD_NAME.MEMBRANE_FILLING_CYCLE].MIN_VALUE;
        maxValue = ADVANCE_SETUP_RESTRICTION[APPDATA.FIELD_NAME.MEMBRANE_FILLING_CYCLE].MAX_VALUE;
        maxDigitAfterDecimal = 0;
        incrementValue = 1;
        break;
      case APPDATA.FIELD_NAME.PRIME_CHIP_WITH_OPTION.BUFFER:
        handleSetSkipPriming(APPDATA.ENUM.SKIP_PRIMING.OFF);
        break;
      case APPDATA.FIELD_NAME.PRIME_CHIP_WITH_OPTION.SAMPLE:
        handleSetSkipPriming(APPDATA.ENUM.SKIP_PRIMING.ON);
        break;
      default:
        break;
    }

    if (value !== undefined) {
      dispatch(
        modalActions.showModal({
          modalHeader: e.currentTarget.id,
          value,
          callback: onChange2,
          maxValue,
          minValue,
          maxDigitAfterDecimal,
          incrementValue,
          info,
        }),
      );
    }
  };

  const showCalculatorModal = (
    v,
    e,
    modalHeader,
    incrementValue = INCREMENT_VALUE,
    maxDigitAfterDecimal = MAX_DIGIT_AFTER_DECIMAL,
    minValue = 0,
    maxValue = 50,
  ) => {
    const value = Number(v);

    if (value !== undefined) {
      dispatch(
        modalActions.showModal({
          modalHeader,
          value,
          callback: onChange2,
          maxValue,
          minValue,
          incrementValue,
          maxDigitAfterDecimal,
        }),
      );
    }
  };

  const onChangeNum = (v) => {
    handleChangePrimingVolume(Number(v).toFixed(1));
  };

  const onDecrease = () => {
    if (Number(primingVolume) > 0) {
      handleChangePrimingVolume((Number(primingVolume) - 0.1).toFixed(1));
    }
  };

  const onIncrease = () => {
    if (Number(primingVolume) < 50) {
      handleChangePrimingVolume((Number(primingVolume) + 0.1).toFixed(1));
    }
  };

  const generateInputSpinnerField = (
    label,
    onChange,
    onClick,
    value,
    unit,
    disabled,
    onClickDecrease,
    onClickIncrease,
    minValue = 0,
    maxValue = 50,
  ) => {
    const styleCustom = {width: '150px'};
    return (
      <InputFieldSpinner
        label={label}
        value={value}
        unit={unit}
        onChange={onChange}
        onClick={onClick}
        styleCustom={styleCustom}
        maxValue={maxValue}
        minValue={minValue}
        disabled={disabled}
        step={0.1}
        fullWidthInput={false}
        onClickDecrease={onClickDecrease}
        onClickIncrease={onClickIncrease}
        className="generalSpinner"
      />
    );
  };

  const formColumn = (columns, index) => (
    <div
      className="generalSetupFormColumn"
      key={index}
    >
      {columns.map((row, index) => {
        const {
          fieldType,
          label,
          initialValue,
          unit,
          option,
          hidden,
          onChange,
          onClick,
          checked,
          disabled,
          onDecrease,
          onIncrease,
          iconAfter,
          minValue,
          maxValue,
        } = row;
        if (hidden) {
          return null;
        }
        return (
          <div
            className="formRow"
            // eslint-disable-next-line react/no-array-index-key
            key={index}
          >
            {fieldType === select &&
              generateSelectField(label, onClick, option, initialValue, unit, onChange, iconAfter)}
            {fieldType === toggleSwitch && generateSwitchField(label, onChange, checked, iconAfter)}
            {fieldType === toggle && generateToggle(label, onClick)}
            {fieldType === input &&
              generateInputSpinnerField(
                label,
                onChange,
                onClick,
                initialValue,
                unit,
                disabled,
                onDecrease,
                onIncrease,
                minValue,
                maxValue,
              )}
          </div>
        );
      })}
    </div>
  );

  const formCols = [
    [
      {
        fieldType: toggleSwitch,
        label: APPDATA.FIELD_NAME.AUTO_RECOVERY,
        onChange: handleToggleAutoRecovery,
        checked: autoRecoveryEnabled,
        iconAfter: () => {},
      },
      {
        fieldType: select,
        label: APPDATA.FIELD_NAME.SAFETY_THRESHOLD,
        initialValue: manualControlThreshold,
        unit: APPDATA.UNIT.ml,
        hideField: undefined,
        option: MANUAL_CONTROL_THRESHOLD_OPTION,
        onChange: onChange2,
        onClick,
        disabled: false,
        iconAfter: () => {
          //   (
          //   <img
          //     alt={Info}
          //     src={Info}
          //     onClick={onInfoClick}
          //   />
          // )
        },
      },
      {
        fieldType: toggle,
        label: APPDATA.FIELD_NAME.PRIME_CHIP_WITH,
        initialValue: undefined,
        unit: undefined,
        hideField: undefined,
        option: undefined,
        onChange: undefined,
        onClick,
        disabled: false,
      },
      {
        fieldType: input,
        label: APPDATA.FIELD_NAME.PRIMING_VOLUME,
        initialValue: primingVolume,
        unit: APPDATA.UNIT.ml,
        hideField: undefined,
        option: undefined,
        onChange: onChangeNum,
        onClick: (v, e) => showCalculatorModal(v, e, APPDATA.FIELD_NAME.PRIMING_VOLUME),
        disabled: false, // hideMembraneFillingCycle,
        onDecrease,
        onIncrease,
      },
    ],
    [
      {
        fieldType: toggleSwitch,
        label: APPDATA.FIELD_NAME.HIGH_VOLUME_BUFFER,
        onChange: handleToggleHighVolumeBuffer,
        checked: highVolumeBufferEnabled,
        iconAfter: () => {},
      },
      {
        fieldType: toggleSwitch,
        label: APPDATA.FIELD_NAME.AUTO_MIXING,
        onChange: handleToggleAutoMixing,
        checked: autoMixingEnabled,
      },
      {
        fieldType: input,
        label: APPDATA.FIELD_NAME.AUTO_MIXING_EVERY,
        initialValue: mixingInterval,
        unit: APPDATA.UNIT.minutes,
        hideField: undefined,
        option: undefined,
        hidden: !autoMixingEnabled,
        onClick: (v, e) => showCalculatorModal(v, e, APPDATA.FIELD_NAME.AUTO_MIXING_EVERY_TITLE, 1, 0, 1),
        onDecrease: () => handleChangeMixingInterval(mixingInterval - 1),
        onIncrease: () => handleChangeMixingInterval(mixingInterval + 1),
        minValue: 1,
        maxValue: 50,
      },
      {
        fieldType: input,
        label: APPDATA.FIELD_NAME.MIXING_CYCLE,
        initialValue: mixingCycle,
        unit: APPDATA.UNIT.times,
        hideField: undefined,
        option: undefined,
        onClick: (v, e) => showCalculatorModal(v, e, APPDATA.FIELD_NAME.MIXING_CYCLE, 1, 0, 1, 30),
        onDecrease: () => handleChangeMixingCycle(mixingCycle - 1),
        onIncrease: () => handleChangeMixingCycle(mixingCycle + 1),
        minValue: 1,
        maxValue: 30,
      },
    ],
  ];

  return (
    <div>
      <div className="mainPage generalSetup">
        <div className="row rowHeight middleAlign">
          <div className="col-md-7 titlePage">
            <h3>General Setup</h3>
          </div>
        </div>
        <div className="setupMenu">{formCols.map((colData, index) => formColumn(colData, index))}</div>
      </div>
    </div>
  );
}

export default GeneralSetup;
